import { FetchStatusSelector, FetchStatusType } from "@obg/ngrx-utils";
import { CommonState } from "@obg/ngx.common";

import { ACTION_PREFIX, LOGIN_ACTION_TYPE } from "./login.action";

export namespace LoginSelector {
	export const isBusy = (state: CommonState): boolean => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);

	export const isForgotPasswordByEmailSuccess = (state: CommonState): boolean =>
		FetchStatusSelector.isStatus(LOGIN_ACTION_TYPE.resetPasswordByEmail, FetchStatusType.Success)(state);

	export const isForgotPasswordByEmailFailed = (state: CommonState): boolean =>
		FetchStatusSelector.isStatus(LOGIN_ACTION_TYPE.resetPasswordByEmail, FetchStatusType.Fail)(state);

	export const isForgotPasswordByEmailAndSecurityQuestionSuccess = (state: CommonState): boolean =>
		FetchStatusSelector.isStatus(
			LOGIN_ACTION_TYPE.resetPasswordByEmailAndSecurityQuestion,
			FetchStatusType.Success
		)(state);

	export const isForgotPasswordByEmailAndSecurityQuestionFailed = (state: CommonState): boolean =>
		FetchStatusSelector.isStatus(
			LOGIN_ACTION_TYPE.resetPasswordByEmailAndSecurityQuestion,
			FetchStatusType.Fail
		)(state);
}
